module.exports = __webpack_public_path__ + "img/img1.419dcc10.jpg";